import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Card, DatePicker, Form, InputNumber, notification} from 'antd';
import moment from "moment";

import {getTax, updateTaxRate} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {bindActionCreators} from "redux";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateTaxRateForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.taxId !== prevProps.match.params.taxId) this._load();
  }

  _load() {
    const {taxId} = decodeParams(this.props.match.params);
    this.props.getTax({taxId});
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {taxId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        const effectiveDate = moment(values.effectiveDate).startOf('day');
        await this.props.updateTaxRate({...values, effectiveDate, taxId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, tax} = this.props;
    return (
      <Card title="Update Tax Rate">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Tax"
          >
            {tax.name}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Rate"
          >
            {getFieldDecorator('rate', {
              rules: [{
                required: true,
                message: 'Rate is required'
              }, {
                type: 'number',
                min: 0.001,
                max: 0.999,
                message: 'Rate must be a fractional number'
              }]
            })(
              <InputNumber />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Effective Date"
          >
            {getFieldDecorator('effectiveDate', {
              rules: [{
                required: true,
                message: 'Effective date is required'
              }]
            })(
              <DatePicker />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Tax Rate
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

UpdateTaxRateForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  updateTaxRate: PropTypes.func.isRequired,
  getTax: PropTypes.func.isRequired,
  tax: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

const UpdateTaxRatePage = Form.create()(UpdateTaxRateForm);

const mapStateToProps = state => ({
  tax: state.tax.tax || {},
  loading: state.tax.taxLoading || state.tax.updatingTaxRate,
});

const mapDispatchToProps = dispatch => ({
  updateTaxRate: bindActionCreators(updateTaxRate, dispatch),
  getTax: bindActionCreators(getTax, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateTaxRatePage);



// WEBPACK FOOTER //
// ./src/Tax/UpdateTaxRatePage.js